import React from 'react';
import { getJobOfferKindIsAgent } from '@doda/common/src/logics/jobSearchDetail/getJobOfferKind';
import {
  Arg as ApplyParamsArg,
  useApply,
} from 'pages/DodaFront/View/JobSearchDetail/hooks/useApply';
import {
  getOfferKindText,
  measureApply,
} from 'pages/DodaFront/View/JobSearchDetail/logics/analytics';
import { useAppDispatch } from '@doda/pc/src/redux/hooks';
import { FooterAgentButton } from './FooterAgentButton';
import { FooterDirectButton } from './FooterDirectButton';

/**
 * FooterApplyAreaコンポーネントのProps
 */
export interface FooterApplyAreaProps extends Omit<ApplyParamsArg, 'position'> {
  wcnsId: string;
}

/**
 * 求人詳細ボディーの下部
 */
export const FooterApplyArea: React.FC<FooterApplyAreaProps> = ({
  jid,
  directLink,
  hasDirectLink,
  initialTab,
  isScout,
  jobOfferKind,
  wcnsId,
  isCasualInterview,
  worschrsvid,
}) => {
  const dispatch = useAppDispatch();
  const { apply } = useApply({
    jid,
    directLink,
    hasDirectLink,
    initialTab,
    isScout,
    jobOfferKind,
    position: 'bottom',
    isCasualInterview,
    worschrsvid,
  });
  const isAgent = getJobOfferKindIsAgent(jobOfferKind);

  const handleApply = () => {
    dispatch(
      measureApply({
        position: 'Bottom',
        apply: getOfferKindText(jobOfferKind),
        initialTab,
        jid,
      })
    );
    apply();
  };
  return (
    <>
      {isAgent ? (
        <FooterAgentButton
          handleApply={handleApply}
          jobOfferKind={jobOfferKind}
          wcnsId={wcnsId}
        />
      ) : (
        <FooterDirectButton
          handleApply={handleApply}
          jobOfferKind={jobOfferKind}
        />
      )}
    </>
  );
};
